import { render } from "./RiProdcategory03.vue?vue&type=template&id=0796bf25"
import script from "./RiProdcategory03.vue?vue&type=script&lang=js"
export * from "./RiProdcategory03.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory03.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0796bf25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0796bf25', __exports__)) {
    api.reload('0796bf25', __exports__)
  }
  
  module.hot.accept("./RiProdcategory03.vue?vue&type=template&id=0796bf25", () => {
    api.rerender('0796bf25', render)
  })

}


export default __exports__